module.exports = "//cdn.mxpnl.com/static/asset-cache/8d8414331523c127176f6ff7cacb4c2c/iron/common/components/warning/images/no-data-laptop.svg";